<template>
  <teleport to="body">
    <div
        v-if="isLoadingAI"
        class="loading-overlay d-flex align-items-center justify-content-center"
    >
      <span class="loader"></span>
    </div>
  </teleport>
  <teleport to="body">
    <div
        v-if="showSaved"
        class="position-fixed top-0 end-0 p-3"
        style="z-index: 1050;"
    >
      <div class="alert alert-success mb-0">
        Сохранено
      </div>
    </div>
  </teleport>
  <teleport to="body">
    <div
        v-if="showError"
        class="position-fixed top-0 end-0 p-3"
        style="z-index: 1050;"
    >
      <div class="alert alert-danger mb-0">
        Что-то пошло не так, попробуйте позже...
      </div>
    </div>
  </teleport>
  <div class="chat-card">
    <!-- Header -->
    <div
        class="card-header d-flex justify-content-end align-items-center p-1"
        style="border-top: 4px solid #ffa900;"
    >
      <button class="btn btn-xs btn-outline-secondary me-2" @click="loadSettings">
        <i class="bi-arrow-clockwise"></i> Чат по умолчанию
      </button>
      <button class="btn btn-xs btn-outline-secondary me-2" @click="loadHistory">
        <i class="bi-box-arrow-down"></i> Сохраненная версия
      </button>
      <button class="btn btn-xs btn-outline-success" @click="saveHistory">
        <i class="bi-box-arrow-in-down"></i> Сохранить
      </button>
    </div>
    <!-- Body -->
    <div ref="scrollContainer" class="card-body d-flex flex-column">
      <template v-for="(msg, idx) in messages" :key="idx">
        <!-- 1) Assistant: аватар слева, текст прилегает к левому краю -->
        <template v-if="msg.role==='assistant'">
        <div class="d-flex justify-content-start mb-3">
          <img
              src="/avatars/ai.png"
              alt="assistant avatar"
              class="rounded-circle"
              style="width:45px; height:45px;"
          />
          <div v-if="editingIndex!==idx"
               class="bg-light bg-gradient px-2 py-2 rounded-4 ms-2 border border-secondary rounded-start small"
               style="max-width:90%;">
            <!-- JSON-ответ -->
            <pre v-if="isJson(msg.content)" class="json-block m-0"><code v-html="highlight(prettyJson(msg.content))"></code></pre>
            <!-- всё остальное (Markdown, plain-text) -->
            <div v-else v-html="renderMarkdown(msg.content)"></div>
          </div>
          <!-- Inline editor -->
          <div v-else class="d-flex flex-column ms-2 flex-grow-1" style="max-width:90%;">
             <textarea
                 :ref="el => easyMdeRefs[idx] = el"
                 class="message-edit-area mb-2 w-100"
             ></textarea>
            <div>
              <button class="btn btn-sm btn-primary me-2" @click="saveEdit(idx)" :disabled="!editedContent.trim()">
                Сохранить
              </button>
              <button class="btn btn-sm btn-secondary" @click="cancelEdit">
                Отмена
              </button>
            </div>
          </div>
          <!-- Кнопка "Редактировать" -->
          <button
              v-if="editingIndex !== idx && canEdit(idx)"
              class="btn p-0 align-self-end ms-1"
              @click="startEdit(idx)"
              aria-label="Редактировать"
          >
            <img
                src="/avatars/edit.png"
                width="20"
                height="20"
            />
          </button>
          <!-- Кнопка "Удалить" -->
          <button
              v-if="editingIndex === null && canDelete(idx)"
              class="btn p-0 align-self-end"
              @click="deleteMessage(idx)"
              aria-label="Удалить"
          >
            <img src="/avatars/delete.png" width="20" height="20" alt="delete"/>
          </button>
        </div>
        <div v-if="idx === messages.length - 1 && editingIndex !== idx"
             class="text-start" style="margin-left: 52px;">
        <button class="btn btn-sm btn-primary" @click="useContent(idx)">
          Использовать контент
        </button>
        </div>
        </template>

        <!-- 2) System и User: текст справа, аватар тоже справа -->
        <template v-else>
          <div class="d-flex justify-content-end mb-3">
            <!-- 1) Кнопка "Редактировать" слева -->
            <button
                v-if="editingIndex !== idx && canEdit(idx)"
                class="btn p-0 align-self-end"
                @click="startEdit(idx)"
                aria-label="Редактировать"
            >
              <img src="/avatars/edit.png" width="20" height="20" alt="edit icon"/>
            </button>
            <!-- Кнопка "Удалить" -->
            <button
                v-if="editingIndex === null && canDelete(idx)"
                class="btn p-0 align-self-end"
                @click="deleteMessage(idx)"
                aria-label="Удалить"
            >
              <img src="/avatars/delete.png" width="20" height="20" alt="delete"/>
            </button>
            <!-- 2) Текст или инлайн-редактор -->
            <div v-if="editingIndex !== idx"
                 class="px-2 py-2 rounded-4 me-2 rounded-end ms-1"
                 :class="msg.role === 'user'
                         ? 'user-bg border'
                         : 'system-bg text-white border'"
                 style="max-width:90%;"
            >
              <p class="small mb-0">{{ msg.content }}</p>
            </div>
            <div
                v-else
                class="d-flex flex-column ms-2 flex-grow-1 px-2"
                style="max-width:100%;">
             <textarea
                 :ref="el => easyMdeRefs[idx] = el"
                 class="message-edit-area mb-2 w-100"
             ></textarea>
              <div class="text-end">
                <button class="btn btn-sm btn-primary me-2" @click="saveEdit(idx)" :disabled="!editedContent.trim()">
                  Сохранить
                </button>
                <button class="btn btn-sm btn-secondary" @click="cancelEdit">
                  Отмена
                </button>
              </div>
            </div>

            <!-- 3) Аватар справа -->
            <img
                :src="msg.role === 'user'
        ? '/avatars/user.png'
        : '/avatars/system.png'"
                alt="avatar"
                class="rounded-circle"
                style="width:45px; height:45px;"
            />
          </div>
          <div v-if="isLastUserIdx(idx) && editingIndex === null" class="text-end" style="margin-right: 52px;">
            <button class="btn btn-sm btn-primary" @click="sendToAI">
              Отправить в чат
            </button>
          </div>
        </template>

      </template>
    </div>
  </div>
</template>

<script>
import { ref, watch, computed, onMounted, nextTick } from 'vue'
import EasyMDE from 'easymde'
import 'easymde/dist/easymde.min.css'
import MarkdownIt from 'markdown-it'
import axios from 'axios'
import hljs from 'highlight.js/lib/core'
import jsonLang from 'highlight.js/lib/languages/json'
import 'highlight.js/styles/github.css'
import { sanitizeHtml } from '@/utils/sanitize'

hljs.registerLanguage('json', jsonLang)

export default {
  name: 'ChatPanel',
  props: {
    contentId: {
      type: [String, Number],
      required: true
    },
    streamId: {
      type: [String, Number],
      required: true
    }
  },
  emits: ['clear', 'close', 'accepted'],
  setup(props, { expose, emit }) {
    const messages = ref([])
    const draft = ref('')

    const editingIndex  = ref(null)
    const editedContent = ref('')
    let easyMdeInstance = null
    const easyMdeRefs = ref([])

    const showSaved  = ref(false)
    const showError = ref(false)
    const isLoadingAI = ref(false)

    const scrollContainer = ref(null)
    const AI_PROFILE_KEY = 'content_generation_v1'
    const streamReasoning = ref(null)
    const isReasoningLoaded = ref(false)

    const DTO_FIELDS = new Set([
      'title', 'body', 'metaDescription', 'leadParagraph', 'slug',
      'image', 'imageAlt', 'status'
    ])

    const extractDto = (src, out = {}) => {
      if (src && typeof src === 'object') {
        for (const [key, val] of Object.entries(src)) {
          if (DTO_FIELDS.has(key)) {
            out[key] = val
          } else if (typeof val === 'object') {
            extractDto(val, out)
          }
        }
      }
      return out
    }

    const md = new MarkdownIt({ html: false, linkify: true, typographer: true })
    const renderMarkdown = text => sanitizeHtml(md.render(text))

    const isJson = txt => {
      try { JSON.parse(txt); return true }
      catch { return false }
    }

    const prettyJson  = raw => JSON.stringify(JSON.parse(raw), null, 2)

    const highlight   = str =>
        sanitizeHtml(hljs.highlight(str, { language: 'json' }).value)

    const normalizeReasoning = value => {
      if (value === null || value === undefined) return null
      if (typeof value === 'string') {
        const trimmed = value.trim()
        return trimmed || null
      }
      if (typeof value === 'number' && Number.isFinite(value)) return String(value)
      if (typeof value === 'boolean') return String(value)
      return null
    }

    const resolveReasoningFromSettings = settings => {
      if (!settings || typeof settings !== 'object') return null
      if (Object.prototype.hasOwnProperty.call(settings, 'reasoning')) {
        return normalizeReasoning(settings.reasoning)
      }
      for (const [key, value] of Object.entries(settings)) {
        if (String(key || '').toLowerCase() === 'reasoning') {
          return normalizeReasoning(value)
        }
      }
      return null
    }

    const loadReasoningSetting = async () => {
      if (isReasoningLoaded.value) return
      isReasoningLoaded.value = true
      try {
        const { data } = await axios.get(`/api/streams/${props.streamId}`)
        streamReasoning.value = resolveReasoningFromSettings(data?.settings)
      } catch (err) {
        isReasoningLoaded.value = false
        console.error('Не удалось загрузить настройки стрима для reasoning', err)
      }
    }

    watch(
        () => messages.value.length,
        () => {
          nextTick(() => {
            const el = scrollContainer.value
            if (el) el.scrollTop = el.scrollHeight
          })
        }
    )

    // 1) Загрузка системных подсказок
    const loadSettings = async () => {
      messages.value = []
      try {
        const {data} = await axios.get(
            `/api/streams/${props.streamId}/generation-settings-summary`
        )
        data.forEach(line =>
            messages.value.push({role: 'system', content: line})
        )
      } catch (err) {
        console.error('Не удалось загрузить настройки генерации', err)
      }
    }

    // 2) Загрузка ранее сохранённой истории
    const loadHistory = async () => {
      messages.value = []
      try {
        const {data} = await axios.get(
            `/api/generation-history/${props.contentId}`
        )
        if (data.messages?.length) {
          data.messages.forEach(m =>
              messages.value.push({role: m.role, content: m.content})
          )
        } else {
          messages.value.push({
            role: 'system',
            content: 'пока нет сохраненной версии...'
          })
        }
      } catch (err) {
        console.error('Не удалось загрузить историю генерации', err)
        messages.value.push({
          role: 'system',
          content: 'Ошибка при загрузке истории'
        })
      }
    }

    // 3) Сохранение текущего чата
    const saveHistory = async () => {
      try {
        await axios.put(
            `/api/generation-history/${props.contentId}`,
            {contentId: props.contentId, messages: messages.value}
        )
        showSaved.value = true
        setTimeout(() => showSaved.value = false, 2000)
      } catch (err) {
        console.error('Не удалось сохранить историю генерации', err)
      }
    }

    // разрешить редактировать только последнее сообщение,
    // либо любые system, если в чате только они
    const lastIsUserAfterSystem = computed(() => {
      const len = messages.value.length
      if (len < 2) return false
      return messages.value[len - 1].role === 'user'
          && messages.value.slice(0, len - 1).every(m => m.role === 'system')
    })

    // прежний флаг «все system»
    const hasOnlySystem = computed(
        () => messages.value.length > 0
            && messages.value.every(m => m.role === 'system')
    )

    // теперь canEdit:
    const canEdit = idx => {
      if (lastIsUserAfterSystem.value) {
        // если был сначала только system, а потом user — можно редактировать любые
        return true
      }
      if (hasOnlySystem.value) {
        // если вообще только system — можно редактировать все system
        return messages.value[idx].role === 'system'
      }
      // в остальных случаях — только последнее сообщение
      return idx === messages.value.length - 1
    }

    // удалить можно только последнее не-system
    const canDelete = idx =>
        canEdit(idx) && messages.value[idx].role !== 'system'

    function deleteMessage(idx) {
      messages.value.splice(idx, 1)
      if (editingIndex.value === idx) cancelEdit()
    }

    const formattedForEditor = txt =>
        isJson(txt) ? prettyJson(txt) : txt

    const startEdit = idx => {
      editingIndex.value = idx
      editedContent.value = formattedForEditor(messages.value[idx].content)

      nextTick(() => {
        const el = easyMdeRefs.value[idx]
        if (!el) return
        easyMdeInstance = new EasyMDE({
          element: el,
          initialValue: editedContent.value,
          autoDownloadFontAwesome: false,
          spellChecker: false,
        })
        // синхронизируем значение обратно в editedContent
        easyMdeInstance.codemirror.on('change', () => {
          editedContent.value = easyMdeInstance.value()
        })
      })
    }

    const saveEdit = async idx => {
      if (!editedContent.value.trim()) {
        return
      }
      const isAssistant = messages.value[idx].role === 'assistant'
      if (isAssistant) {
        try {
          const { data } = await axios.post(
              `/api/util/${props.streamId}/checkJson`,
              editedContent.value,
              {
                headers: { 'Content-Type': 'application/json' },
                responseType: 'text',
                transformRequest: [(d) => d]
              }
          )
          messages.value[idx].content = data
        } catch (e) {
          console.error('Не удалось проверить JSON', e)
          messages.value[idx].content = editedContent.value
        }
      } else {
        messages.value[idx].content = editedContent.value
      }
      editingIndex.value = null
      easyMdeInstance?.toTextArea()
      easyMdeInstance = null
      editedContent.value = ''

      saveHistory()
    }

    const cancelEdit = () => {
      editingIndex.value = null
      easyMdeInstance?.toTextArea()
      easyMdeInstance = null
      editedContent.value = ''
    }

    // Сначала пытаемся загрузить историю генерации
    const fetchHistory = async () => {
      try {
        const { data } = await axios.get(
            `/api/generation-history/${props.contentId}`
        )
        // data.messages — List<Message>
        if (data.messages && data.messages.length > 0) {
          messages.value = data.messages.map(m => ({
            role: m.role,
            content: m.content
          }))
          return true
        }
      } catch (err) {
        console.error('Не удалось загрузить историю генерации', err)
      }
      return false
    }

    // Если истории нет или она пуста, грузим системные подсказки
    const fetchSettings = async () => {
      try {
        const { data } = await axios.get(
            `/api/streams/${props.streamId}/generation-settings-summary`
        )
        data.forEach(line => {
          messages.value.push({ role: 'system', content: line })
        })
      } catch (err) {
        console.error('Не удалось загрузить настройки генерации', err)
      }
    }

    onMounted(async () => {
      const hasHistory = await fetchHistory()
      if (!hasHistory) {
        await fetchSettings()
      }
      await loadReasoningSetting()
    })

    const addUserMessage = text => {
      messages.value.push({role: 'user', content: text})
    }
    const clearUserMessages = () => {
      messages.value = messages.value.filter(m => m.role === 'system')
    }

    // только system+user, без assistant
    const onlySystemAndUser = computed(
        () => messages.value.every(m => m.role === 'system' || m.role === 'user')
    )

    // проверка: это последний элемент и он от user
    const isLastUserIdx = idx =>
        onlySystemAndUser.value &&
        idx === messages.value.length - 1 &&
        messages.value[idx].role === 'user'

    // отправка на /api/ai/send
    const sendToAI = async () => {
      isLoadingAI.value = true
      try {
        await loadReasoningSetting()

        const payloadMessages = messages.value.map(m => ({ role: m.role, content: m.content }))
        const numericStreamId = Number(props.streamId)
        const requestBody = {
          streamId: Number.isFinite(numericStreamId) ? numericStreamId : props.streamId,
          profileKey: AI_PROFILE_KEY,
          messages: payloadMessages
        }
        if (streamReasoning.value) {
          requestBody.overrides = { reasoning: streamReasoning.value }
        }

        const { data } = await axios.post('/api/ai/execute', requestBody)
        const role = typeof data?.role === 'string' && data.role ? data.role : 'assistant'
        const content = typeof data?.content === 'string'
          ? data.content
          : JSON.stringify(data?.content ?? '')
        messages.value.push({ role, content })

        await saveHistory()
      } catch (err) {
        showError.value = true
        setTimeout(() => showError.value = false, 3000)
      } finally {
        isLoadingAI.value = false
      }
    }

    const send = async () => {
      const text = draft.value.trim()
      if (!text) return
      // 1) добавляем в чат
      messages.value.push({role: 'user', content: text})
      draft.value = ''
      // 2) и сразу шлём всё на ИИ
      await sendToAI()
    }

    const useContent = (idx) => {
      const raw = messages.value[idx]?.content
      if (raw == null) return

      let payload
      try { payload = JSON.parse(raw) } catch { payload = raw }

      emit('accepted', payload)
    }

    expose({ addUserMessage, clearUserMessages, sendToAI })

    return { messages, draft, send, editingIndex, editedContent,
      loadSettings, loadHistory, saveHistory, showSaved,
      startEdit, saveEdit, cancelEdit, easyMdeRefs,
      canDelete, deleteMessage, canEdit, isLastUserIdx, sendToAI,
      showError, isLoadingAI, renderMarkdown, scrollContainer,
      isJson, prettyJson, highlight, useContent, extractDto }
  }
}
</script>

<style scoped>
.chat-card {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.card-body {
  padding: 10px;
  flex:1;
  overflow-y:auto;
}
.message-edit-area {
  width: 100%;
  padding: 0.5rem;
  font-size: 0.9rem;
  line-height: 1.4;
  background-color: #fffbeb;       /* очень бледно-жёлтый фон */
  border: 1px solid #ffd324;       /* жёлтый бордер */
  border-radius: 0.5rem;           /* скруглённые углы */
  resize: vertical;                /* разрешаем менять высоту */
  transition: background-color 0.2s;
}
.message-edit-area:focus {
  background-color: #fff8d1;       /* чуть более насыщенный при фокусе */
  outline: none;
  box-shadow: 0 0 0 0.2rem rgba(255, 211, 36, 0.25);
}
.user-bg {
  background-color: #dffadb !important;
  border-color:   #8edda3 !important;
}
.system-bg {
  background-color: #2b9abf !important;
  border-color:   #0208fc !important;
}
.loading-overlay {
  position: fixed;     /* фиксируется относительно viewport */
  inset: 0;            /* top:0; right:0; bottom:0; left:0 */
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.4);
  z-index: 2000;       /* над всем */
  overflow: hidden;
}
.loader {
  width: 48px;
  height: 48px;
  border: 3px solid #FFF;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  position: relative;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}
.loader::after {
  content: '';
  position: absolute;
  box-sizing: border-box;
  left: 20px;
  top: 31px;
  border: 10px solid transparent;
  border-right-color: #FFF;
  transform: rotate(-40deg);
}
@keyframes rotation {
  0%   { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.json-block,          /* сам <pre> */
.json-block code,     /* вложенный <code> */
.hljs {               /* на всякий случай, если забудете класс */
  /* сохраняем отступы, но разрешаем переносы */
  white-space: pre-wrap;   /* переносит при нехватке ширины */
  overflow-wrap: anywhere; /* ломает «очень длинные слова/URL/строки» */
}
.btn-xs {
  padding: 0.2rem 0.4rem;
  font-size: 0.8rem;
  border-radius: 0.3rem;
}
</style>
